import {
  deleteCouponApi,
  generateCouponApi,
  getAllCouponApi,
  getSingleCouponApi,
  updateCouponApi,
} from "../../api/ecommerce/CouponsApi";
import {
  getAllOrdersApi,
  getAllSellerOrdersApi,
  updateOrderStatusApi,
  shipOrderApi,
  cancelCustomerOrderApi,
  printManifestOrderApi,
  printInvoiceOrderApi,
  printLabelOrderApi,
  magicImageUrlApi,
  videosMaPApi,
  getMagicImageUrlApi,
  fetchMagicAPI,
  mapOrderAPI,
  fetchAllMagicAPI,
  deleteVideoImageMapAPI,
  createShiprocketOrderApi,
  GetCouriersListApi,
  updateVideoImageMapAPI,
  updateRtoStatusApi,
  cancelRtoRequestApi,
  getAllRtoRequestsApi,
  getSingleRtoRequestApi,
  createReturnShiprocketOrderApi,
  createReplaceShiprocketOrderApi,
  getRtoCouriersListApi,
  shipRtoNowApi,
  generateRtoManifestApi,
  generateRtoLabelApi,
  generateRtoInvoiceApi,
  getCustomOrdersApi,
  createCustomOrderApi,
  uploadCustomOrderFileApi,
} from "../../api/ecommerce/OrderApi";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
  orderResponse: {},
  orders: [],
  encryptedUrls: [],
  imagemapurls: [],
  singleimagemapurls: [],
  //   coupon: {},
  //   editCoupon: {
  //     isEdit: false,
  //     body: {},
  //   },
  keyword: "",
  sortdir: "",
  sortby: "",
  statusId: "",
  loading: false,
  successful: false,
  uploading: false,
  shipLoading: false,
  manifestLoading: false,
  invoiceLoading: false,
  labelLoading: false,
  shipOrder: {},
  CouriersList: {},
  ManifestOrder: {},
  InvoiceOrder: {},
  LabelOrder: {},
  magicimageurl: {},
  videomap: {},
  mapping: null,
  magic: [],
  magicloading: false,
  magicAll: [],
  magicAllloading: false,
  rtoRequests: {},
  singleRtoRequest: {},
  rtoShipOrder: {},
  rtoCouriersList: {},
  rtoManifest: {},
  rtoInvoice: {},
  rtoLabel: {},
  customOrders: {},
  customOrderResponse: {},
  customOrderUploads: [],
  customOrderUploading: false,
};

//ship rocket start

export const createShiprocketOrder = createAsyncThunk(
  "order/createShiprocketOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createShiprocketOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const GetCouriersList = createAsyncThunk(
  "order/GetCouriersList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await GetCouriersListApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const shipOrder = createAsyncThunk(
  "order/shipOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await shipOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

export const cancelCustomerOrder = createAsyncThunk(
  "order/cancelCustomerOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await cancelCustomerOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  }
);

// ship rocket end

export const getAllSellerOrders = createAsyncThunk(
  "order/getAllSellerOrders",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllSellerOrdersApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateOrderStatus = createAsyncThunk(
  "order/updateOrderStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateOrderStatusApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getAllOrders = createAsyncThunk(
  "order/getAllOrders",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllOrdersApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getCustomOrders = createAsyncThunk(
  "order/getCustomOrders",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getCustomOrdersApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const createCustomOrder = createAsyncThunk(
  "order/createCustomOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createCustomOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const uploadCustomOrderFile = createAsyncThunk(
  "order/uploadCustomOrderFile",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await uploadCustomOrderFileApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const updateRtoStatus = createAsyncThunk(
  "order/updateRtoStatus",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await updateRtoStatusApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const cancelRtoRequest = createAsyncThunk(
  "order/cancelRtoRequest",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await cancelRtoRequestApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getAllRtoRequests = createAsyncThunk(
  "order/getAllRtoRequests",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getAllRtoRequestsApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getSingleRtoRequest = createAsyncThunk(
  "order/getSingleRtoRequest",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getSingleRtoRequestApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const createReturnShiprocketOrder = createAsyncThunk(
  "order/createReturnShiprocketOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createReturnShiprocketOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const createReplaceShiprocketOrder = createAsyncThunk(
  "order/createReplaceShiprocketOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await createReplaceShiprocketOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getRtoCouriersList = createAsyncThunk(
  "order/getRtoCouriersList",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getRtoCouriersListApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const shipRtoNow = createAsyncThunk(
  "order/shipRtoNow",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await shipRtoNowApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const generateRtoManifest = createAsyncThunk(
  "order/generateRtoManifest",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await generateRtoManifestApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const generateRtoLabel = createAsyncThunk(
  "order/generateRtoLabel",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await generateRtoLabelApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const generateRtoInvoice = createAsyncThunk(
  "order/generateRtoInvoice",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await generateRtoInvoiceApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const printManifestOrder = createAsyncThunk(
  "order/printManifestOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await printManifestOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const printInvoiceOrder = createAsyncThunk(
  "order/printInvoiceOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await printInvoiceOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const printLabelOrder = createAsyncThunk(
  "order/printLabelOrder",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await printLabelOrderApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const getMagicImageUrl = createAsyncThunk(
  "order/getMagicImageUrl",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await getMagicImageUrlApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const magicImageUrl = createAsyncThunk(
  "order/magicImageUrl",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await magicImageUrlApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const videosMaP = createAsyncThunk(
  "order/videosMaP",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await videosMaPApi(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

export const fetchMagicById = createAsyncThunk(
  "orders/fetchMagicById",
  async (orderId, { rejectWithValue }) => {
    try {
      const response = await fetchMagicAPI();
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message ?? err.message,
      });
    }
  },
);

export const fetchAllMagicById = createAsyncThunk(
  "orders/fetchAllMagicById",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await fetchAllMagicAPI(payload);
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message ?? err.message,
      });
    }
  },
);

export const mapOrderStatus = createAsyncThunk(
  "orders/mapOrderStatus",
  async (payload, { rejectWithValue, dispatch }) => {
    try {
      const response = await mapOrderAPI(payload?.orderItemId, {
        ...payload,
      });
      // await dispatch(refreshOrdersData(orderId));
      return response.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.response?.data?.message ?? err.message,
      });
    }
  },
);

export const deleteVideoImageMap = createAsyncThunk(
  "order/deleteVideoImageMap",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await deleteVideoImageMapAPI(payload);
      return response?.data;
    } catch (err) {
      return rejectWithValue({
        errorMessage: err?.message,
      });
    }
  },
);

const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    addKeywordSearch: (state, action) => {
      state.keyword = action.payload;
    },
    addSortDir: (state, action) => {
      state.sortdir = action.payload;
    },
    addSortBy: (state, action) => {
      state.sortby = action.payload;
    },
    addStatusId: (state, action) => {
      state.statusId = action.payload;
    },
    setEncryptedUrls: (state, action) => {
      state.encryptedUrls.push(action);
    },
    setImageMappedUrls: (state, action) => {
      const ind = state.imagemapurls.findIndex(
        (item) => item?.mapUploadID === action?.payload?.mapUploadID,
      );

      if (ind !== -1) {
        console.log("New mappeed id", action.payload);
        state.imagemapurls[ind] = action.payload;
      } else {
        state.imagemapurls.push(action.payload);
      }
    },
    clearEncryptedUrls: (state, action) => {
      state.encryptedUrls = [];
    },
    clearImageMapUrls: (state, action) => {
      state.imagemapurls = [];
    },
    clearCustomOrderUploads: (state) => {
      state.customOrderUploads = [];
    },
  },
  extraReducers: (builder) => {
    // update order status
    builder.addCase(updateOrderStatus.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateOrderStatus.fulfilled, (state, action) => {
      state.orderResponse = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateOrderStatus.rejected, (state) => {
      state.uploading = false;
    });

    // get all seller orders
    builder.addCase(getAllSellerOrders.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllSellerOrders.fulfilled, (state, action) => {
      state.orders = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllSellerOrders.rejected, (state) => {
      state.loading = false;
    });

    // get all orders
    builder.addCase(getAllOrders.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllOrders.fulfilled, (state, action) => {
      state.orders = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(getAllOrders.rejected, (state) => {
      state.loading = false;
    });

    // custom orders
    builder.addCase(getCustomOrders.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCustomOrders.fulfilled, (state, action) => {
      state.customOrders = action?.payload?.response ?? {};
      state.loading = false;
    });
    builder.addCase(getCustomOrders.rejected, (state) => {
      state.loading = false;
      state.customOrders = {};
    });

    builder.addCase(createCustomOrder.pending, (state) => {
      state.uploading = true;
      state.customOrderResponse = {};
    });
    builder.addCase(createCustomOrder.fulfilled, (state, action) => {
      state.customOrderResponse = action?.payload?.response ?? {};
      state.customOrderUploads = [];
      state.uploading = false;
    });
    builder.addCase(createCustomOrder.rejected, (state) => {
      state.uploading = false;
    });

    builder.addCase(uploadCustomOrderFile.pending, (state) => {
      state.customOrderUploading = true;
    });
    builder.addCase(uploadCustomOrderFile.fulfilled, (state, action) => {
      const uploads = action?.payload?.response ?? [];
      state.customOrderUploads = Array.isArray(uploads) ? uploads : [uploads];
      state.customOrderUploading = false;
    });
    builder.addCase(uploadCustomOrderFile.rejected, (state) => {
      state.customOrderUploading = false;
    });

    // RTO requests
    builder.addCase(updateRtoStatus.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(updateRtoStatus.fulfilled, (state, action) => {
      state.orderResponse = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(updateRtoStatus.rejected, (state) => {
      state.uploading = false;
    });

    builder.addCase(cancelRtoRequest.pending, (state) => {
      state.uploading = true;
    });
    builder.addCase(cancelRtoRequest.fulfilled, (state, action) => {
      state.orderResponse = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(cancelRtoRequest.rejected, (state) => {
      state.uploading = false;
    });

    builder.addCase(getAllRtoRequests.pending, (state) => {
      state.loading = true;
      state.rtoRequests = {};
    });
    builder.addCase(getAllRtoRequests.fulfilled, (state, action) => {
      state.rtoRequests = action?.payload?.response ?? [];
      state.loading = false;
    });
    builder.addCase(getAllRtoRequests.rejected, (state) => {
      state.loading = false;
      state.rtoRequests = {};
    });

    builder.addCase(getSingleRtoRequest.pending, (state) => {
      state.loading = true;
      state.singleRtoRequest = {};
    });
    builder.addCase(getSingleRtoRequest.fulfilled, (state, action) => {
      state.singleRtoRequest = action?.payload?.response ?? {};
      state.loading = false;
    });
    builder.addCase(getSingleRtoRequest.rejected, (state) => {
      state.loading = false;
      state.singleRtoRequest = {};
    });

    builder.addCase(createReturnShiprocketOrder.pending, (state) => {
      state.shipLoading = true;
      state.rtoShipOrder = {};
    });
    builder.addCase(createReturnShiprocketOrder.fulfilled, (state, action) => {
      state.shipLoading = false;
      state.rtoShipOrder = action?.payload?.response;
    });
    builder.addCase(createReturnShiprocketOrder.rejected, (state) => {
      state.shipLoading = false;
      state.rtoShipOrder = {};
    });

    builder.addCase(createReplaceShiprocketOrder.pending, (state) => {
      state.shipLoading = true;
      state.rtoShipOrder = {};
    });
    builder.addCase(createReplaceShiprocketOrder.fulfilled, (state, action) => {
      state.shipLoading = false;
      state.rtoShipOrder = action?.payload?.response;
    });
    builder.addCase(createReplaceShiprocketOrder.rejected, (state) => {
      state.shipLoading = false;
      state.rtoShipOrder = {};
    });

    builder.addCase(getRtoCouriersList.pending, (state) => {
      state.shipLoading = true;
      state.rtoCouriersList = {};
    });
    builder.addCase(getRtoCouriersList.fulfilled, (state, action) => {
      state.shipLoading = false;
      state.rtoCouriersList = action?.payload?.response;
    });
    builder.addCase(getRtoCouriersList.rejected, (state) => {
      state.shipLoading = false;
      state.rtoCouriersList = {};
    });

    builder.addCase(shipRtoNow.pending, (state) => {
      state.shipLoading = true;
      state.rtoShipOrder = {};
    });
    builder.addCase(shipRtoNow.fulfilled, (state, action) => {
      state.shipLoading = false;
      state.rtoShipOrder = action?.payload?.response;
    });
    builder.addCase(shipRtoNow.rejected, (state) => {
      state.shipLoading = false;
      state.rtoShipOrder = {};
    });

    builder.addCase(generateRtoManifest.pending, (state) => {
      state.manifestLoading = true;
      state.rtoManifest = {};
    });
    builder.addCase(generateRtoManifest.fulfilled, (state, action) => {
      state.manifestLoading = false;
      state.rtoManifest = action?.payload?.response;
    });
    builder.addCase(generateRtoManifest.rejected, (state) => {
      state.manifestLoading = false;
      state.rtoManifest = {};
    });

    builder.addCase(generateRtoLabel.pending, (state) => {
      state.labelLoading = true;
      state.rtoLabel = {};
    });
    builder.addCase(generateRtoLabel.fulfilled, (state, action) => {
      state.labelLoading = false;
      state.rtoLabel = action?.payload?.response;
    });
    builder.addCase(generateRtoLabel.rejected, (state) => {
      state.labelLoading = false;
      state.rtoLabel = {};
    });

    builder.addCase(generateRtoInvoice.pending, (state) => {
      state.invoiceLoading = true;
      state.rtoInvoice = {};
    });
    builder.addCase(generateRtoInvoice.fulfilled, (state, action) => {
      state.invoiceLoading = false;
      state.rtoInvoice = action?.payload?.response;
    });
    builder.addCase(generateRtoInvoice.rejected, (state) => {
      state.invoiceLoading = false;
      state.rtoInvoice = {};
    });

    // ship order start -------------------------

    builder.addCase(createShiprocketOrder.pending, (state) => {
      state.shipOrder = {};
      state.shipLoading = true;
    });
    builder.addCase(createShiprocketOrder.fulfilled, (state, action) => {
      state.shipOrder = action?.payload?.response;
      state.shipLoading = false;
    });
    builder.addCase(createShiprocketOrder.rejected, (state) => {
      state.shipOrder = {};
      state.shipLoading = false;
    });

    builder.addCase(GetCouriersList.pending, (state) => {
      state.CouriersList = {};
      state.shipLoading = true;
    });
    builder.addCase(GetCouriersList.fulfilled, (state, action) => {
      state.CouriersList = action?.payload?.response;
      state.shipLoading = false;
    });
    builder.addCase(GetCouriersList.rejected, (state) => {
      state.CouriersList = {};
      state.shipLoading = false;
    });


    builder.addCase(shipOrder.pending, (state) => {
      state.shipOrder = {};
      state.shipLoading = true;
    });
    builder.addCase(shipOrder.fulfilled, (state, action) => {
      state.shipOrder = action?.payload?.response;
      state.shipLoading = false;
    });
    builder.addCase(shipOrder.rejected, (state) => {
      state.shipOrder = {};
      state.shipLoading = false;
    });

    builder.addCase(cancelCustomerOrder.pending, (state) => {
      state.shipOrder = {};
      state.shipLoading = true;
    });
    builder.addCase(cancelCustomerOrder.fulfilled, (state, action) => {
      state.shipOrder = action?.payload?.response;
      state.orderResponse = action?.payload?.response;
      state.shipLoading = false;
    });
    builder.addCase(cancelCustomerOrder.rejected, (state) => {
      state.shipOrder = {};
      state.shipLoading = false;
    });

    // ship order end ---------------

    // print order
    builder.addCase(printManifestOrder.pending, (state) => {
      state.ManifestOrder = {};
      state.manifestLoading = true;
    });
    builder.addCase(printManifestOrder.fulfilled, (state, action) => {
      state.ManifestOrder = action?.payload?.response;
      state.manifestLoading = false;
    });
    builder.addCase(printManifestOrder.rejected, (state) => {
      state.ManifestOrder = {};
      state.manifestLoading = false;
    });

    // print invoice order
    builder.addCase(printInvoiceOrder.pending, (state) => {
      state.InvoiceOrder = {};
      state.invoiceLoading = true;
    });
    builder.addCase(printInvoiceOrder.fulfilled, (state, action) => {
      state.InvoiceOrder = action?.payload?.response;
      state.invoiceLoading = false;
    });
    builder.addCase(printInvoiceOrder.rejected, (state) => {
      state.InvoiceOrder = {};
      state.invoiceLoading = false;
    });

    // print label order
    builder.addCase(printLabelOrder.pending, (state) => {
      state.LabelOrder = {};
      state.labelLoading = true;
    });
    builder.addCase(printLabelOrder.fulfilled, (state, action) => {
      state.LabelOrder = action?.payload?.response;
      state.labelLoading = false;
    });
    builder.addCase(printLabelOrder.rejected, (state) => {
      state.LabelOrder = {};
      state.labelLoading = false;
    });

    // get magic url
    builder.addCase(magicImageUrl.pending, (state) => {
      state.magicimageurl = {};
      state.uploading = true;
    });
    builder.addCase(magicImageUrl.fulfilled, (state, action) => {
      state.magicimageurl = action?.payload?.response;
      state.uploading = true;
    });
    builder.addCase(magicImageUrl.rejected, (state) => {
      state.magicimageurl = {};
      state.uploading = false;
    });

    // get magic url
    builder.addCase(videosMaP.pending, (state) => {
      state.videomap = {};
      state.uploading = true;
    });
    builder.addCase(videosMaP.fulfilled, (state, action) => {
      state.videomap = action?.payload?.response;
      state.uploading = false;
    });
    builder.addCase(videosMaP.rejected, (state) => {
      state.videomap = {};
      state.uploading = false;
    });

    // get single magic url
    builder.addCase(getMagicImageUrl.pending, (state) => {
      state.imagemapurls = [];
      state.loading = true;
    });
    builder.addCase(getMagicImageUrl.fulfilled, (state, action) => {
      // state.imagemapurls = action?.payload?.response;
      state.loading = false;
    });
    builder
      .addCase(getMagicImageUrl.rejected, (state) => {
        state.imagemapurls = [];
        state.loading = false;
      })

      // Handle addon payment - added from addonSlice.js

      .addCase(mapOrderStatus.pending, (state) => {
        state.loading = true;
        state.addonError = null;
      })
      .addCase(mapOrderStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.mapping = action?.payload?.response;
      })
      .addCase(mapOrderStatus.rejected, (state, action) => {
        state.loading = false;
        state.addonError = action.payload;
      })
      .addCase(fetchMagicById.pending, (state) => {
        state.magicloading = true;
        state.error = null;
      })
      .addCase(fetchMagicById.fulfilled, (state, action) => {
        state.magicloading = false;
        state.magic = action.payload?.response ?? action.payload;
      })
      .addCase(fetchMagicById.rejected, (state, action) => {
        state.magicloading = false;
        state.error = action.payload;
      })

      .addCase(fetchAllMagicById.pending, (state) => {
        state.magicAllloading = true;
        state.error = null;
      })
      .addCase(fetchAllMagicById.fulfilled, (state, action) => {
        state.magicAllloading = false;
        state.magicAll = action.payload?.response ?? action.payload;
      })
      .addCase(fetchAllMagicById.rejected, (state, action) => {
        state.magicAllloading = false;
        state.error = action.payload;
      });

    // delete video mappeing
    builder.addCase(deleteVideoImageMap.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteVideoImageMap.fulfilled, (state, action) => {
      // state.orders = action?.payload?.response;
      state.loading = false;
    });
    builder.addCase(deleteVideoImageMap.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const {
  addKeywordSearch,
  addSortBy,
  addSortDir,
  addStatusId,
  setEncryptedUrls,
  clearEncryptedUrls,
  setImageMappedUrls,
  clearImageMapUrls,
  clearCustomOrderUploads,
} = orderSlice.actions;
export default orderSlice.reducer;
